import { render, staticRenderFns } from "./project-contacts.vue?vue&type=template&id=03bde89c&"
import script from "./project-contacts.vue?vue&type=script&lang=js&"
export * from "./project-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports